import { BaseModelClient } from './BaseDevModelClient';
import { getPreloadedModel, isPreloaded } from './utils/preloader';
export default class ProductionModelClient extends BaseModelClient {
    isPreloaded(url) {
        return isPreloaded(url.pathname);
    }
    getPreloadedModel(url) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return getPreloadedModel(url.pathname);
    }
}
